<kt-portlet>
  <kt-portlet-header [class]="'card-head-lg'" [viewLoading$]="dataSource.loading$">
    <ng-container ktPortletTitle>
      <span>Follow-Up List</span>
    </ng-container>
  </kt-portlet-header>
  <kt-portlet-body>
    <div class="kt-form kt-margin-b-30">
      <div class="kt-form__filtration row">
        <div class="col-md-2 kt-margin-bottom-10-mobile">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>User</mat-label>
            <input type="text" matInput #userEle [matAutocomplete]="auto" />
            <button
              *ngIf="userSelected"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="selectedUser('')"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete
              [panelWidth]="auto"
              #auto="matAutocomplete"
              [displayWith]="this | getUserName"
              (optionSelected)="selectedUser($event.option.value)"
            >
              <mat-option *ngFor="let option of userOptions" [value]="option">
                <span> {{ option.name }} </span>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div class="col-md-2 kt-margin-bottom-10-mobile">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>{{ 'PATIENT.TABLE.STATUS' | translate }}</mat-label>
            <mat-select
              [(value)]="filterStatus"
              (selectionChange)="paginator.firstPage(); loadFollowUpList()"
              placeholder="Status"
            >
              <mat-option>All</mat-option>
              <mat-option value="true">Not Completed</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-2 kt-margin-bottom-10-mobile">
          <div class="kt-form__control">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>From Date</mat-label>
              <input
                matInput
                [formControl]="startDateCreated"
                [matDatepicker]="startDatePickerCreated"
                [max]="maxDate"
                ktDateMask
                maxlength="10"
                placeholder="MM/DD/YYYY"
                (dateChange)="setMinDateCreated($event)"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="startDatePickerCreated"
              ></mat-datepicker-toggle>
              <mat-datepicker #startDatePickerCreated></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div class="col-md-2 kt-margin-bottom-10-mobile">
          <div class="kt-form__control">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>To Date</mat-label>
              <input
                matInput
                [formControl]="toDateCreated"
                [matDatepicker]="toDatePickerCreated"
                ktDateMask
                maxlength="10"
                placeholder="MM/DD/YYYY"
                [min]="minDate"
                (dateChange)="setMaxDateCreated($event)"
              />
              <mat-datepicker-toggle matSuffix [for]="toDatePickerCreated"></mat-datepicker-toggle>
              <mat-datepicker #toDatePickerCreated></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div class="kt-form__control clear-btn">
          <a
            (click)="clearDateFilterCreated()"
            class="text-primary"
            style="display: flex; align-items: center"
            >Clear</a
          >
        </div>
      </div>
      <div class="kt-form__filtration row"></div>
    </div>
    <div class="mat-table-wrapper">
      <mat-table
        class="lmat-elevation-z8"
        #table
        [dataSource]="dataSource"
        matSort
        #sort1="matSort"
        matSortActive="id"
        matSortDirection="desc"
        matSortDisableClear
      >
        <ng-container matColumnDef="contact">
          <mat-header-cell *matHeaderCellDef>Contact</mat-header-cell>
          <mat-cell *matCellDef="let ele">
            <div *ngIf="allContacts.length != 0 && allContacts[ele.contact_id]">
              {{ allContacts[ele.contact_id] | getEntityName }}
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="type">
          <mat-header-cell *matHeaderCellDef>Type</mat-header-cell>
          <mat-cell *matCellDef="let ele">{{ ele.transaction_type | titlecase }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
          <mat-cell *matCellDef="let ele">{{ ele.name }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
          <mat-cell *matCellDef="let ele">
            <span
              class="label label-inline label-light-{{ ele.status | statusColor }} font-weight-bold"
              >{{ ele.status | titlecase }}</span
            >
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="attempts">
          <mat-header-cell *matHeaderCellDef>Attempts</mat-header-cell>
          <mat-cell *matCellDef="let ele">{{ ele.attempts_count }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="dueDate">
          <mat-header-cell *matHeaderCellDef>Due Date</mat-header-cell>
          <mat-cell *matCellDef="let ele">{{
            ele.follow_up_date + ' UTC' | date : 'MMM dd, h:mm a'
          }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="createdBy">
          <mat-header-cell *matHeaderCellDef>Created By</mat-header-cell>
          <mat-cell *matCellDef="let ele">
            <div *ngIf="allUsers.length != 0 && allUsers[ele.created_by]">
              {{ allUsers[ele.created_by].userName || '' }}
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="createdOn">
          <mat-header-cell *matHeaderCellDef>Created On</mat-header-cell>
          <mat-cell *matCellDef="let ele">{{
            ele.created + ' UTC' | date : 'MMM dd, h:mm a'
          }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="comments">
          <mat-header-cell *matHeaderCellDef>Comments</mat-header-cell>
          <mat-cell *matCellDef="let ele" style="height: 30px">
            <div class="symbol symbol-20 mr-2 ml-2" matTooltip="Comments">
              <div class="symbol-label" style="background-color: white">
                <i
                  (click)="openComments(ele); $event.stopPropagation()"
                  class="flaticon2-chat-1 icon-lg"
                ></i>
              </div>
              <i class="symbol-badge bg-danger" *ngIf="ele.number_of_comments !== 0"></i>
            </div>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns" class="sticky-header"></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedColumns"
          (click)="editFollowup(row)"
        ></mat-row>
      </mat-table>
      <div
        class="mat-table-message"
        *ngIf="!dataSource.hasItems"
        translate="GLOBAL.NO_RECORDS_FOUND"
      >
        No Records Found
      </div>
      <div
        class="mat-table-message"
        *ngIf="dataSource.isPreloadTextViewed$ | async"
        translate="GLOBAL.PLEASE_WAIT"
      >
        Please Wait...
      </div>
    </div>
    <div class="mat-table-bottom">
      <mat-spinner [diameter]="20" *ngIf="dataSource.loading$ | async"></mat-spinner>
      <mat-paginator
        [pageSize]="10"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
  </kt-portlet-body>
</kt-portlet>
